// import "bootstrap/dist/css/bootstrap.min.css";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Header from "../components/Navbar/index";
// import Landing from "../components/Landing";
// import LandingUpload from "../components/Carousal";
// import { AdminLogin } from "../components/Login/index";
// import NewProduct from "../components/Product";
// import Notification from "../components/Notification/index";
// import OrderList from "../components/Orders";
// import ProductDetails from "../components/Product/ProductDetails";
// import SalesReport from "../components/Sales/index";
// import UserDetails from "../components/User/index";
// import ErrorPage from "./../components/Error/index";
// import { Courier } from "../components/Courier";
// import { UpdateProduct } from "../components/Product/UpdateProduct";
// import { ProductOfMonth } from "../components/Product/ProductOfMonth";

// function App() {
//   const location = useLocation();
   
//   return (
//     <>
    
//       <BrowserRouter path="/" basename={process.env.PUBLIC_URL}>
//         <Header />
//         <Routes>
//           <Route path="/" element={<AdminLogin />} />
//           <Route path="/landing" element={<Landing />} />
//           <Route path="/landingUpload" element={<LandingUpload />} />
//           <Route path="/orderList" element={<OrderList />} />
//           <Route path="/salesReport" element={<SalesReport />} />
//           <Route path="/newProduct" element={<NewProduct />} />
//           <Route path="/productDetails" element={<ProductDetails />} />
//           <Route path="/updateProduct/:productId" element={<UpdateProduct />} />
//           <Route path="/userDetails" element={<UserDetails />} />
//           <Route path="/notification" element={<Notification />} />
//           <Route path="/courier" element={<Courier />} />
//           <Route path="productOfMonth" element={<ProductOfMonth />} />
//           <Route path="*" element={<ErrorPage />} />
//         </Routes>
//       </BrowserRouter>
//     </>
//   );
// }

// export default App;

import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "../components/Navbar/index";
import Landing from "../components/Landing";
import LandingUpload from "../components/Carousal";
import { AdminLogin } from "../components/Login/index";
import NewProduct from "../components/Product";
import Notification from "../components/Notification/index";
import OrderList from "../components/Orders";
import ProductDetails from "../components/Product/ProductDetails";
import SalesReport from "../components/Sales/index";
import UserDetails from "../components/User/index";
import ErrorPage from "./../components/Error/index";
import { Courier } from "../components/Courier";
import { UpdateProduct } from "../components/Product/UpdateProduct";
import { ProductOfMonth } from "../components/Product/ProductOfMonth";

function App() {
  return (
    <BrowserRouter path="/" basename={process.env.PUBLIC_URL}>
      <HeaderWrapper />
      <Routes>
        <Route path="/" element={<AdminLogin />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/landingUpload" element={<LandingUpload />} />
        <Route path="/orderList" element={<OrderList />} />
        <Route path="/salesReport" element={<SalesReport />} />
        <Route path="/newProduct" element={<NewProduct />} />
        <Route path="/productDetails" element={<ProductDetails />} />
        <Route path="/updateProduct/:productId" element={<UpdateProduct />} />
        <Route path="/userDetails" element={<UserDetails />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/courier" element={<Courier />} />
        <Route path="/productOfMonth" element={<ProductOfMonth />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

// This component ensures useLocation() is used inside BrowserRouter
function HeaderWrapper() {
  const location = useLocation();
  return location.pathname !== "/" ? <Header /> : null;
}

export default App;
